import { createFileRoute } from "@tanstack/react-router";
import AdminChatSandbox from "@/pages/admin/AdminChatSandbox";

export const Route = createFileRoute("/_adminLayout/admin/chat-sandbox")({
  component: AdminChatSandbox,
});
